import { render, staticRenderFns } from "./CounselorAccount.vue?vue&type=template&id=56d4df42&scoped=true&"
import script from "./CounselorAccount.vue?vue&type=script&lang=js&"
export * from "./CounselorAccount.vue?vue&type=script&lang=js&"
import style0 from "./CounselorAccount.vue?vue&type=style&index=0&id=56d4df42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d4df42",
  null
  
)

export default component.exports